import {provideRouter, RouterConfig} from "@angular/router";
import {HomeComponent} from "./home.component";
import {IndexComponent} from "./index.component";
import {HomePanel} from "./home/home.panel.component";
import {VehicleEditorComponent} from "./vehicles/vehicle.editor.component";
import {ContractEditorComponent} from "./contracts/contract.editor.component";
import {InfractionEditorComponent} from "./infractions/infraction.editor.component";
import {ConfigPanel} from "./config/config.panel.component";
import {UnderConstruction} from "./under.construction.component";
import {ConfigBanksComponent} from "./config/banks/config.banks.component";
import {BankEditorComponent} from "./config/banks/bank.editor.component";
import {ConfigRolesComponent} from "./config/roles/config.roles.component";
import {RolEditorComponent} from "./config/roles/rol.editor.component";
import {ConfigOperatorsComponent} from "./config/operators/config.operators.component";
import {OperatorEditorComponent} from "./config/operators/operator.editor.component";
import {ConfigInfractionTypesComponent} from "./config/infractionTypes/config.infractionTypes.component";
import {InfractionTypeEditorComponent} from "./config/infractionTypes/infractionType.editor.component";
import {ClientPanel} from "./client/client.panel.component";
import {PayReceiptComponent} from "./client/payReceipt/payReceipt.component";
import {ConfigClientDocumentsComponent} from "./config/clientFiles/config.clientDocuments.component";
import {ConfigMailTemplatesComponent} from "./config/mailConfig/config.mailTemplates.component";
import {MailTemplateEditorComponent} from "./config/mailConfig/mailTemplate.editor.component";
import {ConfigStateComponent} from "./config/states/config.state.component";
import {StateEditorComponent} from "./config/states/state.editor.component";
import {KmHistoryEditorComponent} from "./kmHistory/kmHistory.editor.component";
import {ProcedureEditorComponent} from "./procedures/procedures.editor.component";
import {PatentPaymentEditorComponent} from "./patentPayment/patentPayment.editor.component";
import {VehicleBrandEditorComponent} from "./config/vehicleBrands/vehicleBrand.editor.component";
import {ConfigVehicleBrandsComponent} from "./config/vehicleBrands/config.vehicleBrands.component";

import {ConfigClientProcedureDocumentsComponent} from "./config/clientProcedureFiles/config.clientProcedureDocuments.component";
import {ConfigClientKmDocumentsComponent} from "./config/clientKmFiles/config.clientKmDocuments.component";
import {ConfigClientPatentDocumentsComponent} from "./config/clientPatentFiles/config.clientPatentDocuments.component";
import {PendingProcedureEditorComponent} from "./pendingProcedures/pendingProcedures.editor.component";
import {SingleProcedureEditorComponent} from "./procedures/singleProcedures.editor.component";
import {ProcedureNewComponent} from "./procedures/procedures.new.component";
import {BankSelectorComponent} from "./login/bankSelector.component";
import {RequestProcedureComponent} from "./client/requestProcedure/requestProcedure.component.ts";

const routes: RouterConfig = [
    {path: '', redirectTo: 'login', pathMatch: 'full'},
    {path: 'login', component: IndexComponent},
    {
        path: 'app/home', component: HomeComponent,
        children: [
            {path: '', redirectTo: 'adminHome', pathMatch: 'full'},
            {path: 'adminHome', component: HomePanel},
            {path: 'editVehicle/:contractId/:vehicleId/:contractEdit', component: VehicleEditorComponent},
            {path: 'createVehicle', component: VehicleEditorComponent},
            {path: 'createVehicle/:contractId', component: VehicleEditorComponent},
            {path: 'editContract/:contractId', component: ContractEditorComponent},
            {path: 'createContract', component: ContractEditorComponent},
            {path: 'editInfraction/:infractionId', component: InfractionEditorComponent},
            {path: 'createInfraction', component: InfractionEditorComponent},
            {path: 'editKmHistory/:vehicleId', component: KmHistoryEditorComponent},
            {path: 'editProcedure/:vehicleId', component: ProcedureEditorComponent},
            {path: 'editSingleProcedure/:procedureId', component: SingleProcedureEditorComponent},
            {path: 'editPendingProcedure/:procedureId', component: PendingProcedureEditorComponent},
            {path: 'editPatentPayment/:vehicleId', component: PatentPaymentEditorComponent},
            {path: 'createProcedure', component: ProcedureNewComponent},
            {
                path: 'config', component: ConfigPanel,
                children: [
                    {path: '', redirectTo: 'infractionTypes', pathMatch: 'full'},
                    {path: 'infractionTypes', component: ConfigInfractionTypesComponent},
                    {path: 'editInfractionType/:infractionTypeId', component: InfractionTypeEditorComponent},
                    {path: 'createInfractionType', component: InfractionTypeEditorComponent},
                    {path: 'states', component: ConfigStateComponent},
                    {path: 'editState/:stateId', component: StateEditorComponent},
                    {path: 'createState', component: StateEditorComponent},
                    {path: 'operators', component: ConfigOperatorsComponent},
                    {path: 'editOperator/:userId', component: OperatorEditorComponent},
                    {path: 'createOperator', component: OperatorEditorComponent},
                    {path: 'cities', component: UnderConstruction},
                    {path: 'ocDocuments', component: UnderConstruction},
                    {path: 'banks', component: ConfigBanksComponent},
                    {path: 'editBank/:bankId', component: BankEditorComponent},
                    {path: 'createBank', component: BankEditorComponent},
                    {path: 'permissions', component: ConfigRolesComponent},
                    {path: 'editRol/:rolId', component: RolEditorComponent},
                    {path: 'createRol', component: RolEditorComponent},
                    {path: 'entes', component: UnderConstruction},
                    {path: 'clientDocuments', component: ConfigClientDocumentsComponent},
                    {path: 'vehicleBrands', component: ConfigVehicleBrandsComponent},
                    {path: 'editVehicleBrand/:vehicleBrandId', component: VehicleBrandEditorComponent},
                    {path: 'createVehicleBrand', component: VehicleBrandEditorComponent},
                    {path: 'clientProcedureDocuments', component: ConfigClientProcedureDocumentsComponent},
                    {path: 'clientKmDocuments', component: ConfigClientKmDocumentsComponent},
                    {path: 'clientPatentDocuments', component: ConfigClientPatentDocumentsComponent}
                ]
            },
            {
                path: 'client', component: ClientPanel,
                children: [
                    {path: '', redirectTo: 'home', pathMatch: 'full'},
                    {path: 'home', component: HomePanel},
                    {path: 'payReceipt', component: PayReceiptComponent},
                    {path: 'myProfile', component: UnderConstruction},
                    {path: 'contact', component: UnderConstruction},
                    {path: 'bankSelector', component: BankSelectorComponent},
                    {path: 'requestProcedure', component: RequestProcedureComponent}
                ]
            },
            {path: 'mailTemplateConfig', component: ConfigMailTemplatesComponent},
            {path: 'editMailTemplate/:mailTemplateId', component: MailTemplateEditorComponent},
            {path: 'createMailTemplate', component: MailTemplateEditorComponent},
        ]
    },
];

export const APP_ROUTER_PROVIDERS = [
    provideRouter(routes)
];


/** WEBPACK FOOTER **
 ** ./src/app/app.routes.ts
 **/